import { defineComponent as _defineComponent } from 'vue'
import MyProjectsButtonArea from '@/views/my-projects/components/MyProjectsButtonArea.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { computed } from 'vue';
import useUser from '@/mixins/useUser';
import { InvoiceStatus } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceButtons',
  setup(__props) {

const {
  invoice, isViewInvoiceLoading, isSendInvoiceLoading
} = useInvoice();
const { tUserFallback: t } = useUser('self');

const isDraft = computed(() => invoice.value?.status === 'DRAFT');
const isUnpaid = computed(() => {
  if (!invoice.value) return false;
  return [
    InvoiceStatus.Unpaid,
    InvoiceStatus.Due,
    InvoiceStatus.Open,
    InvoiceStatus.Sent
  ].includes(invoice.value.status);
});
const isPaid = computed(() => invoice.value?.status === 'PAID');
const isCancelled = computed(() => invoice.value?.status === 'CANCELLED');
const isCancellationCreated = computed(() => invoice.value?.status === 'CANCELLATION_CREATED');
const isExtended = computed(() => !!invoice.value?.expansionDays);

function showViewButton() {
  return isPaid.value || isCancelled.value || isCancellationCreated.value;
}


return { __sfc: true,invoice, isViewInvoiceLoading, isSendInvoiceLoading, t, isDraft, isUnpaid, isPaid, isCancelled, isCancellationCreated, isExtended, showViewButton, MyProjectsButtonArea, BCXButton }
}

})